import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { trackPageView } from './utils/analytics';
import LandingPage from './components/LandingPage';
import Downloads from './components/Downloads';
import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import ClientList from './components/ClientList';
import ClientDetail from './components/ClientDetail';
import EmpresaCadastro from './components/EmpresaCadastro';
import FeatureDetails from './components/FeatureDetails';
import MarketingTagsInit from './components/MarketingTagsInit';
import LandingComercio from './components/LandingComercio';
import LandingServicos from './components/LandingServicos';
import PoliticaPrivacidade from './components/PoliticaPrivacidade';

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #667eea',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Componente para redirecionar usuários logados
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

// Componente para rastrear mudanças de rota
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

const AppRoutes = () => {
  return (
    <Router>
      <MarketingTagsInit />
      <PageTracker />
      <Routes>
        <Route 
          path="/" 
          element={<LandingPage />} 
        />

        <Route
          path="/erp-para-comercio"
          element={<LandingComercio />}
        />

        <Route
          path="/erp-para-servicos"
          element={<LandingServicos />}
        />
        
        <Route
          path="/downloads"
          element={<Downloads />}
        />

        <Route
          path="/politica-de-privacidade"
          element={<PoliticaPrivacidade />}
        />
        
        <Route 
          path="/funcionalidades" 
          element={<FeatureDetails />} 
        />
        
        <Route 
          path="/funcionalidades/:moduloId" 
          element={<FeatureDetails />} 
        />
        
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/clientes" 
          element={
            <ProtectedRoute>
              <Layout>
                <ClientList />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/clients" 
          element={
            <ProtectedRoute>
              <Layout>
                <ClientList />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/clientes/:id" 
          element={
            <ProtectedRoute>
              <Layout>
                <ClientDetail />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/clients/:id" 
          element={
            <ProtectedRoute>
              <Layout>
                <ClientDetail />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/clientes/novo" 
          element={
            <ProtectedRoute>
              <Layout>
                <EmpresaCadastro />
              </Layout>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
};

export default App; 